export default __webpack_public_path__ + "static/media/video-off.e3f95fa4.svg";